import PagePlaceholder from "../components/PagePlaceholder";

function Catering() {
  return <PagePlaceholder i18nKey="cateringPage" />;
}

export default Catering;
